import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon, useSvgId } from './icon-utils';

export function ArrowUpIcon({ fill = 'white', ...props }: SimpleIconInterface): JSX.Element {
  const clipPathId = useSvgId('arrow-up-clip');

  return (
    <SimpleIcon fill="none" height="16" viewBoxDimensions="0 0 16 16" width="16" {...props}>
      <defs>
        <clipPath id={clipPathId}>
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          clipRule="evenodd"
          d="M8.73916 0.466087C8.33089 0.0578538 7.66903 0.0578538 7.26079 0.466087L0.988792 6.73809C0.580559 7.14632 0.580559 7.80822 0.988792 8.21645C1.39703 8.62465 2.05889 8.62465 2.46716 8.21645L6.95463 3.72892V14.7946C6.95463 15.3719 7.42263 15.8399 7.99996 15.8399C8.57729 15.8399 9.04533 15.3719 9.04533 14.7946V3.72892L13.5328 8.21645C13.941 8.62465 14.6029 8.62465 15.0112 8.21645C15.4194 7.80822 15.4194 7.14632 15.0112 6.73809L8.73916 0.466087Z"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
    </SimpleIcon>
  );
}
